import React, { Component } from 'react';
import { MuiGrid, MuiTypography, MuiButton } from '../../ui/MaterialUIComponents';
import theme from '../../../assests/theme';

class BubbleComponent extends Component {
    constructor(props) {
        super(props)
    };

    render() {
        const { label, isSelected, onBubbleClick, selectedObj, parentObj, grandParentObj, displayGroupName } = this.props;

        const selectStyleIfTrue = { width: "15px", height: "40px", background: theme.palette.primary.lighter }
        const selectStyleIfFalse = { width: "15px", height: "40px", background: "white", }

        const typographyStyleIfTrue = { color: theme.textColor,padding: 0 }
        const typographyStyleIfFalse = { color: theme.textColor,padding: 0 }

        let styleForContainer = (isSelected == true || isSelected == undefined) ? selectStyleIfTrue : selectStyleIfFalse
        let styleForTypography = (isSelected == true || isSelected == undefined) ? typographyStyleIfTrue : typographyStyleIfFalse


        return (

            <MuiButton xs id="bubble"  onClick={() => onBubbleClick(selectedObj, parentObj, grandParentObj)} id="button">

                <MuiGrid container xs alignContent="center" justify="center" style={styleForContainer}>

                    <MuiGrid item >
                        {displayGroupName === undefined ?
                            <MuiTypography style={styleForTypography} variant={theme.typographyStyles.CAPTION}>{label}</MuiTypography>
                            :
                            <MuiTypography style={styleForTypography} variant={theme.typographyStyles.CAPTION}>{displayGroupName}</MuiTypography>
                        }

                    </MuiGrid>

                </MuiGrid>

            </MuiButton>
        )
    };
};
export default BubbleComponent;

